<!-- Gallery main component -->
<div class="photo-gallery">
  <div class="gallery-images">
    <div
      class="gallery-image"
      *ngFor="let image of visibleImages"
      (click)="openImage(image)"
    >
      <img src="{{ image.content }}" alt="Photo Gallery Image" />
    </div>
  </div>
  <div class="gallery-navigation">
    <button (click)="previous()">&#10094;</button>
    <button (click)="next()">&#10095;</button>
  </div>
</div>

<!-- Angular Material Dialog Template -->
<ng-template #imageDialog let-data>
  <br />
  <h5 class="container">{{ this.enlargedImage.title }}</h5>
  <div class="image-container">
    <img src="{{ this.enlargedImage.content }}" alt="Image" />
  </div>
  <mat-dialog-actions class="gallery-navigation">
    <button mat-button (click)="previousImage()">&#10094;</button>
    <button mat-button (click)="nextImage()">&#10095;</button>
  </mat-dialog-actions>
</ng-template>
